import { createRouter, createWebHistory } from 'vue-router'

// 修改组件名为多单词
const PageHome = () => import('../components/pages/PageHome.vue')
const PageAbout = () => import('../components/pages/PageAbout.vue')
const PageContact = () => import('../components/pages/PageContact.vue')
const PageRegister = () => import('../components/pages/PageRegister.vue')
const PageEscrow = () => import('../components/pages/PageEscrow.vue')
const PageNews = () => import('../components/pages/PageNews.vue')
const PageYmjj = () => import('../components/pages/PageYmjj.vue')
const PageYssm = () => import('../components/pages/PageYssm.vue')

const PageBqsm = () => import('../components/pages/PageBqsm.vue')
const routes = [
    {
        path: '/',
        name: 'Home',
        component: PageHome,
    },
    {
        path: '/about',
        name: 'About',
        component: PageAbout,
    },
    {
        path: '/yssm',
        name: 'Yssm',
        component: PageYssm,
    },
    {
        path: '/bqsm',
        name: 'bqsm',
        component: PageBqsm,
    },
    {
        path: '/contact',
        name: 'Contact',
        component: PageContact,
    },
    {
        path: '/register',
        name: 'Register',
        component: PageRegister,
    },
    {
        path: '/escrow',
        name: 'PageEscrow',
        component: PageEscrow,
    },
    {
        path: '/ymjj',
        name: 'PageYmjj',
        component: PageYmjj,
    },
    {
        path: '/news',
        name: 'PageNews',
        component: PageNews,
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

export default router